import React from "react";
import {
  AppBar,
  Toolbar,
  Typography,
  useMediaQuery,
  IconButton,
} from "@material-ui/core";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import { Link, useLocation } from "react-router-dom";
import MenuIcon from "@material-ui/icons/Menu";
import logo from "../images/high1digital-logo.jpg";
import { NavbarDrawer } from "./NavbarDrawer";

const useStyles = makeStyles((theme) => ({
  rootAppBar: {
    backgroundColor: "white",
    boxShadow: "none",
  },
  toolbar: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
  },
  logoWrapper: {
    display: "flex",
    alignItems: "center",
    flexGrow: 1,
    cursor: "pointer",
    marginLeft: "5%",
  },
  logoImg: {
    width: 100,
    height: 100,
    objectFit: "contain",
  },
  navlinks: {
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    width: "100%",
  },
  link: {
    textDecoration: "none",
    color: "black",
    fontSize: 17,
    fontWeight: 600,
    padding: theme.spacing(2),
    transition: "color 150ms ease-in-out",
    "&:hover": {
      color: "rgb(223, 32, 32)",
    },
  },
  activeLink: {
    color: "rgb(223, 32, 32) !important",
  },
  menuButton: {
    marginLeft: theme.spacing(1),
  },
}));

const NAV_ITEMS = [
  { label: "Home", path: "/" },
  // { label: "Portfolio", path: "/portfolio" }, // left commented if you want dropdown later
  // { label: "Services", path: "/services" },
  { label: "About Us", path: "/about" },
  { label: "Blog", path: "/blog" },
  { label: "Contact Us", path: "/contact" },
  { label: "Careers", path: "/careers" },
  { label: "Refund Policy", path: "/refunds" },
  { label: "T&C", path: "/tandc" },
];

export const Navbar = () => {
  const classes = useStyles();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const location = useLocation();
  const [drawerOpen, setDrawerOpen] = React.useState(false);

  const activePath = (p) => {
    // treat root specially: location.pathname === '/'
    if (p === "/") return location.pathname === "/";
    // For other routes, check prefix match
    return location.pathname.startsWith(p);
  };

  return (
    <AppBar
      position="static"
      className={classes.rootAppBar}
    >
      <Toolbar className={classes.toolbar}>
        <Typography
          component="div"
          className={classes.logoWrapper}
        >
          <Link
            to="/"
            aria-label="High1Digital Home"
          >
            <img
              src={logo}
              alt="High1Digital Consulting Pvt. Ltd"
              className={classes.logoImg}
            />
          </Link>
        </Typography>

        {isMobile ? (
          <>
            <IconButton
              edge="end"
              color="inherit"
              aria-label="open menu"
              onClick={() => setDrawerOpen(true)}
              className={classes.menuButton}
            >
              <MenuIcon style={{ color: "#1d1d1d" }} />
            </IconButton>

            <NavbarDrawer
              open={drawerOpen}
              onClose={() => setDrawerOpen(false)}
              navItems={NAV_ITEMS}
              activePathChecker={activePath}
            />
          </>
        ) : (
          <nav
            className={classes.navlinks}
            aria-label="Primary navigation"
          >
            {NAV_ITEMS.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className={`${classes.link} ${
                  activePath(item.path) ? classes.activeLink : ""
                }`}
                aria-current={activePath(item.path) ? "page" : undefined}
              >
                {item.label}
              </Link>
            ))}
          </nav>
        )}
      </Toolbar>
    </AppBar>
  );
};

export default Navbar;
